<div class="cv-marker-picker" (click)="$event.stopPropagation()">
  <button
    type="button"
    class="cv-marker-picker__trigger"
    [disabled]="disabled"
    (click)="toggle($event)"
    title="Change marker icon"
    aria-label="Change marker icon"
    [attr.aria-expanded]="open()"
    [class.cv-marker-picker__trigger--active]="open()"
  >
    <img [src]="iconSrc(selectedIconId)" alt="" class="cv-marker-picker__trigger-img" />
  </button>
</div>

<!-- Fixed-position popup — outside any overflow:hidden ancestor -->
<div
  #popup
  *ngIf="open()"
  class="cv-marker-picker__popup"
  role="listbox"
  aria-label="Marker styles"
  [style.top.px]="popupTop()"
  [style.left.px]="popupLeft()"
  (click)="$event.stopPropagation()"
>
  <div class="cv-marker-picker__grid">
    <button
      *ngFor="let file of markerFiles; let i = index"
      type="button"
      class="cv-marker-picker__option"
      role="option"
      [attr.aria-selected]="selectedIconId === i"
      [class.cv-marker-picker__option--selected]="selectedIconId === i"
      (click)="select(i, $event)"
      [title]="markerLabels[file] || file.replace('_', ' ').replace('.svg', '')"
    >
      <img [src]="iconSrc(i)" [alt]="file" />
    </button>
  </div>
</div>
